import React from 'react';

import { Badge } from '@vimeo/bokeh';
import { Video } from '@vimeo/gctl-api/models/components/schemas/video/Video';
import { translate } from '@vimeo/i18n-runtime';

import { AdvertBadge } from '../AdvertBadge/AdvertBadge';
import { AiBadge } from '../AiBadge/AiBadge';
import { DolbyVisionBadge } from '../DolbyVisionBadge/DolbyVisionBadge';

type VideoBadgesProps = {
  isStreaming?: boolean;
  isRatedMature?: boolean;
  is360Video?: boolean;
  isDolbyVision?: boolean;
  isHdr10?: boolean;
  isHdr10Plus?: boolean;
  aiContent?: Video['metadata']['aiContent'];
  isAdvert?: boolean;
};

export const VideoBadges = ({
  isStreaming,
  isRatedMature,
  is360Video,
  isDolbyVision,
  isHdr10,
  isHdr10Plus,
  aiContent,
  isAdvert,
}: VideoBadgesProps) => (
  <>
    {isStreaming ? (
      <Badge variant="mature" size="sm">
        {translate('LIVE')}
      </Badge>
    ) : null}
    {isRatedMature ? (
      <Badge variant="mature" size="sm">
        {translate('Mature')}
      </Badge>
    ) : null}
    {is360Video ? (
      <Badge variant="not-yet-rated" size="sm" color="text-secondary" borderColor="text-secondary">
        360
      </Badge>
    ) : null}
    {isDolbyVision ? <DolbyVisionBadge /> : null}
    {isHdr10 ? (
      <Badge variant="not-yet-rated" size="sm" color="text-secondary" borderColor="text-secondary">
        HDR 10
      </Badge>
    ) : null}
    {isHdr10Plus ? (
      <Badge variant="not-yet-rated" size="sm" color="text-secondary" borderColor="text-secondary">
        HDR 10+
      </Badge>
    ) : null}
    {!!aiContent ? <AiBadge aiContent={aiContent} /> : null}
    {isAdvert ? <AdvertBadge /> : null}
  </>
);
